// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"29ae66d9","122":"48b1f323","194":"b2d2c94c","204":"a013cb3b","207":"a9aff72c","213":"fc3621de","221":"35fff04c","453":"258b012d","456":"a1389acf","713":"8bf244d2","732":"4462740c","744":"52d136fe","813":"ddacb773"}[chunkId] + ".chunk.js";
};